import React from 'react'
import './Inquiry_modal.css'
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Contact_form from '../../../contact-us/contact-form/Contact_form';

const Inquiry_modal = (props) => {
    return (
        <>
            <Modal
                {...props}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                className='Inquiry_modal'
            >
                <Modal.Header closeButton>

                </Modal.Header>
                <Modal.Title className=" text-center">
                    <h5 className='inqtitle'>Inquire Now</h5>
                </Modal.Title>
                <Modal.Body>

                    <Contact_form />
                </Modal.Body>

            </Modal>
        </>
    )
}

export default Inquiry_modal